import * as React from "react";
import PropTypes from 'prop-types';

const SvgBackArrow2022 = props => {
  if (props.id !== "_svgbackarrow2022") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M32.555 21.545a1.5 1.5 0 100-3H11.15l9.048-9.049a1.495 1.495 0 00-2.113-2.113L6.55 18.916c-.043.044-.084.09-.12.137a1.496 1.496 0 00.09 2.077c.04.05.083.098.13.145l11.234 11.234c.666.666 1.681.732 2.266.147.586-.586.52-1.6-.146-2.267l-8.844-8.844h21.394zm-13.61 9.904l-1.06 1.06 1.06-1.06zm0 0l1.06-1.06-1.06 1.06z" fill="#202020" /></svg>;
};

SvgBackArrow2022.displayName = "_svgbackarrow2022";
SvgBackArrow2022.propTypes = {
  id: PropTypes.string
};
SvgBackArrow2022.defaultProps = {
  id: ''
};
export default SvgBackArrow2022;